import { render, staticRenderFns } from "./BuffetLayout.vue?vue&type=template&id=c2e3c0ba&scoped=true&"
import script from "./BuffetLayout.vue?vue&type=script&lang=js&"
export * from "./BuffetLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e3c0ba",
  null
  
)

export default component.exports